import { Outlet } from 'react-router';
import logo_cms from '../../assets/images/promo-a.png';
import logo_cms_2x from '../../assets/images/promo-a2x.png';

const PublicLayout = () => {
	return (
		<div className='relative min-h-screen overflow-hidden bg-transparent'>
			<div className='pointer-events-none absolute inset-0 section-gradient' />
			<div className='pointer-events-none absolute inset-0 grid-dot opacity-40' />
			<div className='relative mx-auto flex min-h-screen w-full max-w-7xl'>
				<div className='flex w-full flex-col lg:w-1/2'>
					<div className='flex-1 p-4 sm:p-8'>
						<div className='surface mx-auto w-full max-w-xl p-6 sm:p-8'>
							<Outlet />
						</div>
					</div>
					<div className='px-6 pb-6 text-sm text-muted-foreground sm:px-8'>© 2026. All Rights Reserved.</div>
				</div>

				<div className='hidden w-1/2 items-center justify-center p-6 lg:flex'>
					<div className='surface soft-float w-full p-8'>
						<div className='mx-auto max-w-md text-center'>
							<div>
								<img
									className='mx-auto h-auto w-full max-w-sm rounded-xl object-contain'
									src={logo_cms}
									srcSet={`${logo_cms_2x} 2x`}
									alt='Quang Trung software - Cung cấp dịch vụ thiết kế và vận hành website trọn gói.'
								/>
							</div>
							<div className='space-y-2 py-6'>
								<h3 className='text-xl font-semibold'>
									<b>Hệ thống quản trị nội dung website</b>
								</h3>
								<p className='text-muted-foreground'>Quản lý nội dung blog tư vấn</p>
								<p className='text-muted-foreground'>Quản lý nội dung sản phẩm</p>
								<p className='text-muted-foreground'>Quản lý đơn hàng</p>
								<p className='text-muted-foreground'>Quản lý nội dung landingpage</p>
								<p className='text-muted-foreground'>Quản lý Từ khóa seo web</p>
								<p className='text-muted-foreground'>Báo cáo tổng hợp</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PublicLayout;
